import { render } from "./StudyStatus.vue?vue&type=template&id=285e40de&scoped=true"
import script from "./StudyStatus.vue?vue&type=script&lang=js"
export * from "./StudyStatus.vue?vue&type=script&lang=js"

import "./StudyStatus.vue?vue&type=style&index=0&id=285e40de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-285e40de"]])

export default __exports__